import jQuery from "jquery"

// Support legacy build system.
window.jQuery = jQuery
window.$ = jQuery